import axios from 'axios';
import {Message} from 'element-ui';
import router from "@/router";
import store from "@/store";


// http response拦截器 添加一个响应拦截器

axios.interceptors.response.use(result=>{
	// Message.success(result.data.token)
	if(result.data.token != null){
		window.localStorage.setItem("token",result.data.token)
	}
    /* 这里的result.status是服务器的响应码，result.data.status才是服务器饭回来的响应码 */
    if(result.status && result.status == 200 && result.data.status == 500){
        /* 返回的错误信息从服务端返回的msg中获取 */
        Message.error({message: result.data.msg})

        /* 返回一个空 之后只需要判断是否有数据就可以判断请求是否成功 */
        return;
    }

    if(result.data.code == 200 && result.data.msg){
        console.log(result.data.msg)
        Message.success({message: result.data.msg})
    }
	
	if(result.data.code == 500){
	    console.log(result.data.msg)
	    Message.error({message: result.data.msg})
	}

    return result.data;

}, error => {
// Message.success('code=500')
    if(error.response.status == 504 || error.response.status == 404){
        Message.error({message:'好像和服务器失去联系了呢(￣▽￣)"'});
    } else if(error.response.status == 403){
        Message.error({message:'权限不足，可以联系管理员来获取权限'});
    } else if(error.response.status == 401){
        Message.error({message:'您尚未登录，请先登录'});
        // getRequest("/tpa-api/admin/logout");
        // 删除用户数据
        window.localStorage.removeItem("user");
        window.localStorage.removeItem("token");
        // 清空菜单
        store.commit('initRoutes', []);
        // 跳转登录页
        router.replace('/', () =>{console.log("跳转成功")}, err => {console.log("跳转失败")});
    } else {
        if(error.response.data.msg){
            Message.error({message:error.response.data.msg});
        } else {
            Message.error({message:'未知错误！请正确操作！！'});
        }
    }

    return;
})



// http request拦截器 添加一个请求拦截器
// axios.interceptors.request.use(function (config) {
//     // Do something before request is sent
//     //window.localStorage.getItem("accessToken") 获取token的value
//     let token = window.localStorage.getItem("token")
//     if (token) {
//         //将token放到请求头发送给服务器,将tokenkey放在请求头中
//         config.headers.token = token;     
//         //也可以这种写法
//         // config.headers['accessToken'] = Token;
//          return config;
//     }
// }, function (error) {
//     // Do something with request error
//     return Promise.reject(error);
// });




/* 定义一个全局变量 */
let base = 'https://bhsens.baolong.biz'
//let base = 'http://localhost:60001/'
// let base = 'http://36.212.232.151:7089'


/* 封装post请求 */
export const postKeyValueRequest=(url,params)=>{
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        transformRequest:[function (data) {
            let ret = '';
            for(let i in data){
                ret += encodeURIComponent(i)+'='+encodeURIComponent(data[i])+'&'
            }
            return ret;
        }],
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
			'token': window.localStorage.getItem("token")
        }
    }).catch(error => {
        console.error("There was an error!", error);
    });

}

export const postFormRequest=(url,params)=>{
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        headers:{
            'Content-Type': 'multipart/form-data',
			'token': window.localStorage.getItem("token")
        }
    }).catch(error => {
        console.error("There was an error!", error);
    });

}
export const postFormRequest1=(url,params)=>{
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: `${base}${url}`,
            data: params,
            headers: {
                "Content-Type": "multipart/form-data",
                token: window.localStorage.getItem("token"),
            },
        })
            .then((resp) => {
                resolve(resp.data);
            })
            .catch((err) => {
                reject(err);
            });
    }).catch(error => {
        console.error("There was an error!", error);
    });

}



/* 封装用json数据进行请求的 get post put delete方法 */
export const postRequest=(url,params)=>{
	let token = window.localStorage.getItem("token");
    return axios({
        method: 'post',
        url:`${base}${url}`,
        data: params,
		headers: {
			'token': token
		}
    })

}

export const putRequest=(url,params)=>{
let token = window.localStorage.getItem("token");
    return axios({
        method: 'put',
        url:`${base}${url}`,
        data: params,
		headers: {
			'token': token
		}
    })

}

export const deleteRequest=(url,params)=>{
	let token = window.localStorage.getItem("token");
	
    return axios({
        method: 'delete',
        url:`${base}${url}`,
        data: params,
		headers: {
			'token': token
		}
    })

}

export const getRequest=(url,params)=>{
    console.log(url)
let token = window.localStorage.getItem("token");
    return axios({
        method: 'get',
        url:`${base}${url}`,
        data: params,
		headers: {
			'token': token
		}
    })
}

// export const getRequest1=(url,params)=>{
//     let token = window.localStorage.getItem("token");
//     console.log(url);
//     return fetch({
//         method: 'get',
//         url:`${base}${url}`,
//         data: params,
//         headers: {
//             'token': token
//         }
//     })
// }

export const getRequest1 = (url, params = {}) => {
    const token = window.localStorage.getItem("token");

    // 构建查询字符串
    const queryString = Object.keys(params).length
        ? '?' + new URLSearchParams(params).toString()
        : '';

    const fullUrl = `${base}${url}${queryString}`;

    return fetch(fullUrl, {
        method: 'GET',
        headers: {
            'token': token
        }
    });
};